import React, { useState, useEffect } from "react";
import { Button, Typography, Table, Space, Popover } from "antd";
import { DatePicker } from "../../../components/antOverrides";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { CloseOutlined } from "@ant-design/icons";
import ModalContentWrapper from "./ModalContentWrapper.style";
import Date from "../../../components/tables/Date";
import moment from "moment";
import _ from "lodash";
import { checkDatesBeforeEndOfMonth } from "../../../components/util/helpers";
import { ClockCircleOutlined } from "@ant-design/icons";
const { Title, Text } = Typography;

const GenerateDateContent = (props) => {
  const { onMouseOver, onMouseOut, hide, handleContinue } = props;
  const [generateDate, setGenerateDate] = useState(null);
  const [generateDates, setGenerateDates] = useState([]);

  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState([]);
  const [changed, setChanged] = useState([]);

  const currentAppLocale = useSelector((state) => state.user.currentAppLocale);
  const activePlanEvents = useSelector(
    (state) => state.plan.activePlan.recurrent_events
  );
  const serverPlanEvents = useSelector(
    (state) => state.plan.serverPlan.recurrent_events
  );
  const orderTimeExtractions = useSelector(
    (state) => state.plan.serverPlan.order_time_extractions
  );
  const conflict_orders = useSelector(
    (state) => state.plan.activeSimulatedPlan.conflict_orders || []
  );
  const intl = useIntl();

  useEffect(() => {
    const grouped = _.groupBy(activePlanEvents, (event) => event.order_id);
    let arr = [];
    let changedArr = [];
    let generatedArr = [];
    const deletedEvents = serverPlanEvents.filter(
      ({ id: serverId }) =>
        !activePlanEvents.some(({ id: activeId }) => serverId === activeId)
    );
    Object.keys(grouped).map((key) => {
      const temp = {
        order_id: grouped[key][0].order_id,
        name: grouped[key][0].order ? grouped[key][0].order.client.name : "",
        order_start_date: grouped[key][0].order
          ? grouped[key][0].order.effective_from
          : null,
        generated_from: moment(),
        supporting_community: grouped[key][0].supporting_community,
        day_center: grouped[key][0].is_day_center,
      };
      arr.push(temp);

      return grouped[key].forEach((item, i) => {
        const serverEvent = serverPlanEvents.filter((j) => j.id === item.id)[0];
        if (
          !serverEvent ||
          (serverEvent &&
            (serverEvent.duration_minutes !== item.duration_minutes ||
              serverEvent.start_time_minutes !== item.start_time_minutes ||
              serverEvent.weekday !== item.weekday ||
              serverEvent.employee_id !== item.employee_id ||
              serverEvent.order_id !== item.order_id ||
              serverEvent.tariff_id !== item.tariff_id ||
              serverEvent.client_tariff_id !== item.client_tariff_id ||
              serverEvent.transportation_cost !== item.transportation_cost ||
              serverEvent.weekday !== item.weekday))
        ) {
          changedArr = [...changedArr, item.order_id];
        }
      });
    });

    deletedEvents.forEach((item, i) => {
      //handle deleted events
      changedArr = [...changedArr, item.order_id];
      const temp = {
        order_id: item.order_id,
        name: item.order ? item.order.client.name : "",
        order_start_date: item.order ? item.order.effective_from : null,
        generated_from: moment(),
        supporting_community: item?.order?.supporting_community,
        day_center: item?.order?.day_center,
      };
      let newArr = arr.filter((i) => i.order_id !== item.order_id);
      newArr.push(temp);
      arr = newArr;
    });

    let uniqueChanged = [...new Set(changedArr)];
    uniqueChanged.forEach((item, i) => {
      generatedArr.push({
        order_id: item,
        generated_from: moment(),
      });
    });

    setItems(arr);
    setSelected(uniqueChanged);
    setChanged(uniqueChanged);
    setGenerateDates(arr);
  }, [activePlanEvents, serverPlanEvents]);

  useEffect(() => {
    setGenerateDate(moment());
  }, []);
  const onContinue = () => {
    handleContinue(generateDates, selected);
    hide();
  };

  const onCancel = async () => {
    hide();
  };

  const onChange = (r, date, dateString) => {
    setGenerateDates([
      ...generateDates.filter((i) => i.order_id !== r.order_id),
      { ...r, generated_from: date },
    ]);
  };

  const disabledDate = (current, r) => {
    const startDate =
      orderTimeExtractions[r.order_id] &&
      orderTimeExtractions[r.order_id].last_approved_event_at
        ? moment(orderTimeExtractions[r.order_id].last_approved_event_at).endOf(
            "day"
          )
        : null;
    const latestValidDate = checkDatesBeforeEndOfMonth(
      conflict_orders,
      r.order_id
    );
    return (
      current &&
      (current <= startDate || //dates before first approved event
        current < moment(r.order_start_date) || //start of order
        current <= moment(latestValidDate) || //dates before end of conflict order
        current <= moment().subtract(3, "months").startOf("month")) //max 3 month limit
    );
  };

  //  {latestValidDate && (
  //   <div>
  //     <Text>
  //       {intl.formatMessage({
  //         id: "app.plans.conflictOrderInTheSameMonth",
  //       })}
  //     </Text>
  //   </div>
  // )}

  const rowSelection = {
    selectedRowKeys: selected,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelected(selectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: changed.includes(record.order_id),
    }),
  };

  const columns = [
    {
      title: intl.formatMessage({
        id: "app.plans.clientName",
      }),
      render: (text, r) => {
        const latestValidDate = checkDatesBeforeEndOfMonth(
          conflict_orders,
          r.order_id
        );
        const content = latestValidDate && (
          <div>
            <Text>
              {`${intl.formatMessage({
                id: "app.plans.conflictOrderInTheSameMonth1",
              })} ${moment(latestValidDate).format("DD/MM/YYYY")}`}
            </Text>
            <br />
            <Text>
              {intl.formatMessage({
                id: "app.plans.conflictOrderInTheSameMonth2",
              })}
            </Text>
          </div>
        );

        return latestValidDate ? (
          <Space>
            <Text>{text}</Text>
            <Popover
              content={content}
              title={intl.formatMessage({
                id: "app.plans.conflictOrderInTheSameMonthTitle",
              })}
            >
              <ClockCircleOutlined style={{ padding: "0 5px", color: "red" }} />
            </Popover>
          </Space>
        ) : (
          <Text>{text}</Text>
        );
      },

      dataIndex: "name",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.order_start_date",
      }),
      dataIndex: "order_start_date",
      render(text) {
        return <Date text={moment(text)} format={"DD/MM/YYYY"} />;
      },
    },
    {
      title: intl.formatMessage({
        id: "app.plans.order_service_type",
      }),
      render: (r) => {
        return (
          <Text>
            {r.supporting_community
              ? intl.formatMessage({
                  id: "app.prospectuses.supporting_community",
                })
              : r.day_center
              ? intl.formatMessage({
                  id: "app.prospectuses.day_center",
                })
              : intl.formatMessage({
                  id: "app.prospectuses.home_care",
                })}
          </Text>
        );
      },
    },

    {
      title: intl.formatMessage({
        id: "app.plans.generatedFrom",
      }),
      dataIndex: "generated_from",
      render: (generated_from, r) => (
        <DatePicker
          defaultValue={generated_from}
          onChange={(date, dateString) => onChange(r, date, dateString)}
          format={"DD/MM/YYYY"}
          disabledDate={(current) => disabledDate(current, r)}
        />
      ),
    },
  ];
  return (
    <ModalContentWrapper direction={currentAppLocale.direction}>
      <div className="top" onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
        <Button
          className="closeBtn"
          type="text"
          shape="circle"
          icon={<CloseOutlined />}
          onClick={hide}
        />
      </div>
      <div style={{ padding: "40px 40px 0 40px" }}>
        <Title level={2}>
          {intl.formatMessage({
            id: "app.plans.generateDateModalTitle",
          })}
        </Title>
        <Text>
          {intl.formatMessage({
            id: "app.plans.generateDateModalDescription",
          })}
        </Text>
        <div
          style={{
            display: "flex",
            width: "100%",
            padding: "20px 0",
            justifyContent: "center",
          }}
        >
          <Table
            rowSelection={{
              type: "checkbox",
              ...rowSelection,
            }}
            rowKey={(record) => record.order_id}
            columns={columns}
            dataSource={items}
            pagination={false}
            bordered
          />
        </div>
      </div>
      <div className="actions">
        <Button
          type="primary"
          onClick={onContinue}
          disabled={!generateDate || selected.length === 0}
        >
          {intl.formatMessage({
            id: "app.actions.finish",
          })}
        </Button>
        <div className="horizontal-divider" />
        <Button onClick={onCancel}>
          {intl.formatMessage({
            id: "app.actions.cancel",
          })}
        </Button>
      </div>
    </ModalContentWrapper>
  );
};

export default GenerateDateContent;
